import { FC } from "react"

import ReservationArticle from "models/ReservationArticle"
import ReservationCartArticle from "models/ReservationCartArticle"
import { Purpose } from "config/constants"
import ArticleWithAssets from "components/ArticleWithAssets/ArticleWithAssets"
import { StatusIndicatorState } from "components/StatusIndicator/StatusIndicator"
import { Guid } from "@/types"

interface IReservationSidebarConfigurationItemProps {
    article: ReservationArticle | ReservationCartArticle
    isNodeArticle?: boolean
    purpose?: Purpose
    inspectedAssetIds?: Guid[]
    damagedAssetIds?: Guid[]
}

const ReservationSidebarConfigurationItem: FC<IReservationSidebarConfigurationItemProps> = ({
    article,
    isNodeArticle,
    purpose,
    inspectedAssetIds,
    damagedAssetIds,
}) => {
    return (
        <ArticleWithAssets
            article={article}
            isNodeArticle={isNodeArticle}
            assets={article.assets}
            statusIndicator={
                article.isAvailable && !(purpose === Purpose.sale && article.hasAutomaticSelectionAssets)
                    ? StatusIndicatorState.green
                    : StatusIndicatorState.red
                }
            purpose={purpose}
            inspectedAssetIds={inspectedAssetIds}
            damagedAssetIds={damagedAssetIds}
            clickableLmid
        />
    )
}

export default ReservationSidebarConfigurationItem
